import {addAuthToAxiosOpts} from '../config/queryopts'
import {useQueryWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import PropTypes from "prop-types";


export const PostDetailsFetcher = (accessToken, uid = null, include_indicators = false) => {
  const uri = (uid) ? `/${uid}` : '';
  return axios.get(`${apiUrlInternal}/posts${uri}${(include_indicators) ? '?include_indicators=true' : ''}`, addAuthToAxiosOpts(accessToken, {})).then(res => res.data);
}

export const usePostDetailsQuery = (uid = null, include_indicators = false, fetcher = PostDetailsFetcher) => {
  return useQueryWithAuthentication(['post-details', uid, include_indicators],
    (accessToken) => fetcher(accessToken, uid, include_indicators))
}

usePostDetailsQuery.propTypes = {
  uid: PropTypes.string.isRequired,
  include_indicators: PropTypes.bool,
};
